import React from "react";

import { withContentful } from "./with-contentful";
import { withLoadedData } from "./with-loaded-data";

export const withData =
    <P extends Record<string, unknown>>(
        Component: React.ComponentType<P & { data: unknown; error?: Error }>,
    ) =>
    (props: P) => {
        const withDataProvider = window.CONTENTFUL_CONFIG
            ? withContentful
            : withLoadedData;
        const ComponentWithData = withDataProvider(Component);
        return <ComponentWithData {...props} />;
    };
